import {
  Button,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { Project } from "models/project_type";
import {
  MdAttachMoney,
  MdBarChart,
  MdEdit,
  MdFileCopy,
  MdMessage,
  MdNoteAdd,
  MdNotifications
} from "react-icons/md";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IExecutivaComponent {
  accountSelected: Project;
}

const ExecutivaComponent = ({ accountSelected }: IExecutivaComponent) => {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <>
      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Ações
      </Text>

      <HStack justifyContent={"flex-start"}>
        <Button
          leftIcon={<MdEdit />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Editar
        </Button>
        <Button
          leftIcon={<MdNoteAdd />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Tarefas
        </Button>
        <Button
          leftIcon={<MdFileCopy />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Arquivos
        </Button>
        <Button
          leftIcon={<MdMessage />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Mensagens
        </Button>
        <Button
          leftIcon={<MdNotifications />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Notificações
        </Button>
      </HStack>
      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Saúde do Projeto
      </Text>

      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Orçamento de Produção"
          value={formatNumber(
            Number(accountSelected?.Orcamento?.total) -
              Number(accountSelected.valorReduzido)
          )}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name="Executado"
          value={formatNumber(Number(0))}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name="Pago"
          value={formatNumber(Number(0))}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name="Saldo"
          value={formatNumber(
            Number(accountSelected?.Orcamento?.total) -
              Number(accountSelected.valorReduzido)
          )}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Meta Ecônomia"
          value={`${Number(accountSelected?.metaEconomia)?.toFixed(2)}%`}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Valor Ecônomia"
          value={formatNumber(Number(accountSelected?.valorEconomia))}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Limite de Manejo"
          value={`${Number(accountSelected?.limiteManejo)?.toFixed(2)}%`}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Valor Manejo"
          value={formatNumber(Number(accountSelected?.valorManejo))}
        />
      
      </SimpleGrid>
    </>
  );
};
export default ExecutivaComponent;
